import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpNodeAffineTransform} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/affine-transform/node"
import {Matrix3x2} from "@cm/math"
import {AnyImageOpContext, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/rotate/node/definition"
import {ImageOpNodeRotateTextureType} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/rotate-texture-type/node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

@registerNode
export class ImageOpNodeOperatorRotate extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeOperatorRotate"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage, angleInDegrees, textureType} = await evaluator.getAll(this.parameters)
        if (angleInDegrees === 0) {
            return sourceImage
        } else {
            const resultImage = imageOpNodeBag.getNode("rotateImage", ImageOpNodeAffineTransform, {
                sourceImage: sourceImage,
                transform: new Matrix3x2().rotate(angleInDegrees),
                addressMode: "wrap",
            })
            const result = imageOpNodeBag.getNode("rotateVectors", ImageOpNodeRotateTextureType, {
                sourceImage: resultImage,
                angleInDegrees: angleInDegrees,
                textureType: textureType,
            })
            return await evaluator.get(result)
        }
    }
}
